import { Container, Typography } from "@material-ui/core"
import BackButton from "components/BackButton/BackButton"
import { useGroupPurchasesContext } from "components/PurchasePage/GroupPurchasesContext"
import { Dispatch, SetStateAction, useEffect, useRef } from "react"
import styled from "styled-components"

const StyledWrapper = styled(Container)`
  margin-top: 120px;
  padding-right: 60px;
  padding-left: 60px;

  ${(p) => p.theme.breakpoints.down("sm")} {
    padding-left: 16px;
    padding-right: 16px;
    margin-top: 94px;
  }
`

const StyledTitle = styled(Typography).attrs({ variant: "h1" })`
  font-size: 40px;
  color: #000;
  text-align: right;
  ${(p) => p.theme.breakpoints.down("sm")} {
    line-height: 1;
    margin-top: 20px;
  }
`

const StyledTextWrapper = styled.div<{ $align?: string }>`
  display: flex;
  flex-direction: column;
  align-items: ${(p) => (p.$align ? p.$align : "center")};
  justify-content: center;
  text-align: right;

  p {
    font-family: "Speedee", "NarkisBlockContent", sans-serif;
    font-size: 20px;
    color: #000;
    margin-right: 0 !important;
    width: 100%;

    :first-child {
      margin-top: 0;
    }
  }

  li {
    font-family: "Speedee", "NarkisBlockContent", sans-serif;
    font-size: 20px;
    color: #000;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    line-height: 1;
    color: #000;
  }
`

type TextsPageProps = {
  title?: string
  text: string
  setRefList?: Dispatch<SetStateAction<any[]>>
  align?: string
}

const TextsPage = ({ title, text, setRefList, align }: TextsPageProps) => {
  const Section1Ref = useRef(null)

  const { setPrevPath, prevPath, setChanged } = useGroupPurchasesContext()

  useEffect(() => {
    if (setRefList && Section1Ref.current) {
      setRefList([Section1Ref])
    }
  }, [Section1Ref])

  return (
    <StyledWrapper ref={Section1Ref}>
      <BackButton
        linkText="חזרה"
        prevPath={prevPath}
        beforeNavigation={() => {
          setChanged(true)
        }}
        afterNavigation={() => {
          setPrevPath(null)
        }}
      />

      <StyledTitle>{title}</StyledTitle>

      <StyledTextWrapper
        dangerouslySetInnerHTML={{ __html: text }}
        $align={align}
      ></StyledTextWrapper>
    </StyledWrapper>
  )
}

export default TextsPage
